import {
    Box,
    Grid
  } from "@mui/material";
import CommerceProductTable from "../../components/cosmeticRank/trendCommerce/CommerceProductTable.jsx";
import CommerceProductTrendChart from "../../components/cosmeticRank/trendCommerce/CommerceProductTrendChart.jsx";
import CommerceProductPriceTrendChart from "../../components/cosmeticRank/trendCommerce/CommerceProductPriceTrendChart.jsx";
import CustomDatePicker from "../../components/CustomDatePicker";
import PaginationWithInfo from "../../components/PaginationWithInfo.jsx";
import { CustomMultiSelect } from "../../components/CustomMultiSelect.jsx";
import { CustomRankChangeCell } from "../../components/CustomRankChangeCall.jsx";
import { useState, useRef, useEffect, useCallback, useMemo} from 'react';
import { useOutletContext } from "react-router-dom";
import { API_BASE_URL } from "../../config/apiDefaultPath.js";
import { backendApiCall } from "../../utils/apiCall.js";


function RankTrendCommerce() {

  // 공통 변수
    const today = new Date();

  /**
   * product table 
   **/
    const [selectedTableDate, setSelectedTableDate] = useState(today);
    const [selectedCategoryType, setSelectedCategoryType] = useState(["전체"]);
    const [selectedCategoryMain, setSelectedCategoryMain] = useState(["전체"]);
    const [selectedCommerce, setSelectedCommerce] = useState(["전체"]);
    const [selectedBrand, setSelectedBrand] = useState(["전체"]);
    const [selectedRank, setSelectedRank] = useState(["전체"]);
    const [selectedRankChange, setSelectedRankChange] = useState(["전체"]);
    const [selectedProductName, setSelectedProductName] = useState(["전체"]);
    const [selectedTrendProduct, setSelectedTrendProduct] = useState([]);
    const [products, setProducts] = useState([]);
    const inputRefTableDate = useRef();
    const [isLoading, setIsLoading] = useState(true);

    const [isCategoryTypeBoxLoading, setIsCategoryTypeBoxLoading] = useState(false);
    const [isCategoryMainBoxLoading, setIsCategoryMainBoxLoading] = useState(false);
    const [isCommerceBoxLoading, setIsCommerceBoxLoading] = useState(false);
    const [isBrandBoxLoading, setIsBrandBoxLoading] = useState(false);
    const [isRankBoxLoading, setIsRankBoxLoading] = useState(false);
    const [isRankChangeBoxLoading, setIsRankChangeBoxLoading] = useState(false);
    const [isProductNameBoxLoading, setIsProductNameBoxLoading] = useState(false);

    const [categoryTypeOptions, setCategoryTypeOptions] = useState([]);
    const [categoryMainOptions, setCategoryMainOptions] = useState([]);
    const [commerceOptions, setCommerceOptions] = useState([]);
    const [brandOptions, setBrandOptions] = useState([]);
    const [rankOptions, setRankOptions] = useState([]);
    const [rankChangeOptions, setRankChangeOptions] = useState([]);
    const [productNameOptions, setProductNameOptions] = useState([]);
    const [chartProducts, setChartProducts] = useState([]);

    const { token } = useOutletContext();
    // const token = getIdToken(user, true);

    const backendApiCallWithToken = useCallback(
      (apiPath, body, setFn, setLoadingFn) =>
        backendApiCall(apiPath, body, setFn, setLoadingFn, token, API_BASE_URL),
      [token]
    );

    // 테이블 페이징 처리
    const [page, setPage] = useState(0);
    const rowsPerPage = 200; // 고정값
    const paginatedProducts = useMemo(() => {
      const start = page * rowsPerPage;
      return products.slice(start, start + rowsPerPage);
    }, [products, page]);
    
    // commerce 드롭박스 데이터 API 호출
    useEffect(() => {
        backendApiCallWithToken(
            "commerce/selectbox/Commerce",
            JSON.stringify({
              selectedTableDate: selectedTableDate
            }),
            setCommerceOptions,
            setIsCommerceBoxLoading
          );
          setSelectedCommerce(["전체"]);
      }, [
        backendApiCallWithToken,
        selectedTableDate
      ]);
    
    // category type 드롭박스 데이터 API 호출
    useEffect(() => {
      if (
          selectedCommerce.length > 0
      ){
          backendApiCallWithToken(
              "commerce/selectbox/CType",
              JSON.stringify({
                  selectedTableDate: selectedTableDate,
                  selectedCommerce: selectedCommerce
              }),
              setCategoryTypeOptions,
              setIsCategoryTypeBoxLoading
          );
          setSelectedCategoryType(["전체"]);
       }    
      }, [
      backendApiCallWithToken,
      selectedTableDate,
      selectedCommerce
      ]);
  
    // main category 드롭박스 데이터 API 호출
    useEffect(() => {
        if (
            selectedCommerce.length > 0
            && selectedCategoryType.length > 0
        ){
            backendApiCallWithToken(
                "commerce/selectbox/CMain",
                JSON.stringify({
                    selectedTableDate: selectedTableDate,
                    selectedCommerce: selectedCommerce,
                    selectedCategoryType: selectedCategoryType
                }),
                setCategoryMainOptions,
                setIsCategoryMainBoxLoading
            );
            setSelectedCategoryMain(["전체"]);
         }    
        }, [
        backendApiCallWithToken,
        selectedTableDate,
        selectedCommerce,
        selectedCategoryType
        ]);

    // brand 드롭박스 데이터 API 호출
    useEffect(() => {
        if (
            selectedCommerce.length > 0
            && selectedCategoryType.length > 0  
            && selectedCategoryMain.length > 0
        ){
          backendApiCallWithToken(
            "commerce/selectbox/Brand",
            JSON.stringify({
              selectedTableDate: selectedTableDate,
              selectedCommerce: selectedCommerce,
              selectedCategoryType: selectedCategoryType,
              selectedCategoryMain: selectedCategoryMain
            }),
            setBrandOptions,
            setIsBrandBoxLoading
          );
          setSelectedBrand(["전체"]);
        }
    }, [
      backendApiCallWithToken,
      selectedTableDate,
      selectedCommerce,
      selectedCategoryType,
      selectedCategoryMain
    ]);

    // rank 드롭박스 데이터 API 호출
    useEffect(() => {
        if (
            selectedCommerce.length > 0
            && selectedCategoryType.length > 0
            && selectedCategoryMain.length > 0
            && selectedBrand.length > 0
        ){
          backendApiCallWithToken(
            "commerce/selectbox/Rank",
            JSON.stringify({
                selectedTableDate: selectedTableDate,
                selectedCommerce: selectedCommerce,
                selectedCategoryType: selectedCategoryType,
                selectedCategoryMain: selectedCategoryMain,
                selectedBrand: selectedBrand
            }),
            setRankOptions,
            setIsRankBoxLoading
          );
          setSelectedRank(["전체"]);
        }
    }, [
      backendApiCallWithToken,
      selectedTableDate,
      selectedCommerce,
      selectedCategoryType,
      selectedCategoryMain,
      selectedBrand
    ]);

    // 순위추이 드롭박스 데이터 API 호출
    useEffect(() => {
        if (
            selectedCommerce.length > 0
            && selectedCategoryType.length > 0
            && selectedCategoryMain.length > 0
            && selectedBrand.length > 0
            && selectedRank.length > 0
        ){
          backendApiCallWithToken(
            "commerce/selectbox/RankChange",
            JSON.stringify({
                selectedTableDate: selectedTableDate,
                selectedCommerce: selectedCommerce,
                selectedCategoryType: selectedCategoryType,
                selectedCategoryMain: selectedCategoryMain,
                selectedBrand: selectedBrand,
                selectedRank: selectedRank,
            }),
            setRankChangeOptions,
            setIsRankChangeBoxLoading
          );
          setSelectedRankChange(["전체"]);
        }
    }, [
      backendApiCallWithToken,
      selectedTableDate,
      selectedCommerce,
      selectedCategoryType,
      selectedCategoryMain,
      selectedBrand,
      selectedRank
    ]);

    // 상품명 드롭박스 데이터 API 호출
    useEffect(() => {
        if (
            selectedCommerce.length > 0
            && selectedCategoryType.length > 0
            && selectedCategoryMain.length > 0
            && selectedBrand.length > 0
            && selectedRank.length > 0
            && selectedRankChange.length > 0
        ){
          backendApiCallWithToken(
            "commerce/selectbox/ProductName",
            JSON.stringify({
                selectedTableDate: selectedTableDate,
                selectedCommerce: selectedCommerce,
                selectedCategoryType: selectedCategoryType,
                selectedCategoryMain: selectedCategoryMain,
                selectedBrand: selectedBrand,
                selectedRank: selectedRank,
                selectedRankChange: selectedRankChange
            }),
            setProductNameOptions,
            setIsProductNameBoxLoading
          );
          setSelectedProductName(["전체"]);
        }
    }, [
      backendApiCallWithToken,
      selectedTableDate,
      selectedCommerce,
      selectedCategoryType,
      selectedCategoryMain,
      selectedBrand,
      selectedRank,
      selectedRankChange
    ]);

    // 상품리스트 테이블 데이터 API 호출
    useEffect(() => {
      setSelectedTrendProduct([]);
        if (
            selectedCommerce.length > 0
            && selectedCategoryType.length > 0
            && selectedCategoryMain.length > 0
            && selectedBrand.length > 0
            && selectedRank.length > 0
            && selectedRankChange.length > 0
            && selectedProductName.length > 0
        ){
          backendApiCallWithToken(
            "commerce/products", 
            JSON.stringify({
                selectedTableDate: selectedTableDate,
                selectedCommerce: selectedCommerce,
                selectedCategoryType: selectedCategoryType,
                selectedCategoryMain: selectedCategoryMain,
                selectedBrand: selectedBrand,
                selectedRank: selectedRank,
                selectedRankChange: selectedRankChange,
                selectedProductName: selectedProductName
            }),
            setProducts,
            setIsLoading
          );
        }
        setPage(0);
    }, [
      backendApiCallWithToken,
      selectedTableDate,
      selectedCommerce,
      selectedCategoryType,
      selectedCategoryMain,
      selectedBrand,
      selectedRank,
      selectedRankChange,
      selectedProductName
    ]);

    // 상품에 대한 추이 그래프 이벤트
    const toggleProduct = (product) => {
      const isSelected = selectedTrendProduct.find((p) => p.ProductName === product.ProductName);
      if (isSelected) {
        setSelectedTrendProduct(selectedTrendProduct.filter((p) => p.ProductName !== product.ProductName));
      } else {
        setSelectedTrendProduct([...selectedTrendProduct, product]);
      }
    };
  
  /**
   * trend chart
   */
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);
    const [selectedChartStartDate, setSelectedChartStartDate] = useState(sevenDaysAgo);
    const [selectedChartEndDate, setSelectedChartEndDate] = useState(today);
    const [isChartLoading, setIsChartLoading] = useState(false);

    // 상품에 대한 추이 그래프 API 호출
    useEffect(() => {
      if (selectedTrendProduct.length > 0){
        backendApiCallWithToken(
            "commerce/chart", 
            JSON.stringify({
              startDate: selectedChartStartDate,
              endDate: selectedChartEndDate,
              selectedProducts: selectedTrendProduct,
            }),
            setChartProducts,
            setIsChartLoading
          );
        }
    }, [
      backendApiCallWithToken,
      selectedChartStartDate, 
      selectedChartEndDate, 
      selectedTrendProduct
    ]);

  return (
    <div>
      <Box display="flex" gap={2}>
        <Box sx={{ px: 0, py: 0 }}>
          {/* 검색창 공간 확보용 */}
          <Box
            width="800px"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p={2}
            border="1px solid #e0e0e0"
            borderBottom="none"
            borderRadius="8px 8px 0 0"
            position="sticky"
            top={0}
            zIndex={2}
            bgcolor="#fff"
          >
            <Box>
              <Grid container spacing={0.3}>
                {/* 날짜 필터 */}
                <Grid item xs={12} sm={6}>
                  <CustomDatePicker 
                    selectedDate={selectedTableDate}
                    setSelectedDate={setSelectedTableDate}
                    inputRef={inputRefTableDate}
                    label="조회 기준일"
                  />
                </Grid>
                {/* 커머스 필터 */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      opacity: isCommerceBoxLoading ? 0.4 : 1,
                      pointerEvents: isCommerceBoxLoading ? "none" : "auto",
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <CustomMultiSelect
                      label="커머스"
                      labelId="commerce"
                      optionItems={commerceOptions}
                      selectedValue={selectedCommerce}
                      onChange={setSelectedCommerce}
                      width="104px"
                    />
                  </Box>
                </Grid>
                {/* 카테고리 구분 필터 */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      opacity: isCategoryTypeBoxLoading ? 0.4 : 1,
                      pointerEvents: isCategoryTypeBoxLoading ? "none" : "auto",
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <CustomMultiSelect
                      label="카테고리 구분"
                      labelId="type-category-1"
                      optionItems={categoryTypeOptions}
                      selectedValue={selectedCategoryType}
                      onChange={setSelectedCategoryType}
                      width="104px"
                    />
                  </Box>
                </Grid>
                {/* 카테고리 필터 */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      opacity: isCategoryMainBoxLoading ? 0.4 : 1,
                      pointerEvents: isCategoryMainBoxLoading ? "none" : "auto",
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <CustomMultiSelect
                      label="카테고리 메인"
                      labelId="main-category-1"
                      optionItems={categoryMainOptions}
                      selectedValue={selectedCategoryMain}
                      onChange={setSelectedCategoryMain}
                      width="104px"
                    />
                  </Box>
                </Grid>
                {/* 브랜드 필터 */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      opacity: isBrandBoxLoading ? 0.4 : 1,
                      pointerEvents: isBrandBoxLoading ? "none" : "auto",
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <CustomMultiSelect
                      label="브랜드"
                      labelId="brand-1st"
                      optionItems={brandOptions}
                      selectedValue={selectedBrand}
                      onChange={setSelectedBrand}
                      width="104px"
                    />
                  </Box>
                </Grid>
                {/* 순위 필터 */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      opacity: isRankBoxLoading ? 0.4 : 1,
                      pointerEvents: isRankBoxLoading ? "none" : "auto",
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <CustomMultiSelect
                      label="순위"
                      labelId="rank-"
                      optionItems={rankOptions}
                      selectedValue={selectedRank}
                      onChange={setSelectedRank}
                      width="104px"
                    />
                  </Box>
                </Grid>
                {/* 순위 변동 필터 */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      opacity: isRankChangeBoxLoading ? 0.4 : 1,
                      pointerEvents: isRankChangeBoxLoading ? "none" : "auto",
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <CustomMultiSelect
                      label="순위 변동"
                      labelId="rank-chan-"
                      optionItems={rankChangeOptions}
                      selectedValue={selectedRankChange}
                      onChange={setSelectedRankChange}
                      width="104px"
                      CustomRankChangeCell={CustomRankChangeCell}
                    />
                  </Box>
                </Grid>
                {/* 상품명 필터 */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      opacity: isProductNameBoxLoading ? 0.4 : 1,
                      pointerEvents: isProductNameBoxLoading ? "none" : "auto",
                      transition: "opacity 0.3s ease",
                      paddingTop: "10px"
                    }}
                  >
                    <CustomMultiSelect
                      label="상품명"
                      labelId="product"
                      optionItems={productNameOptions}
                      selectedValue={selectedProductName}
                      onChange={setSelectedProductName}
                      width="765px"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Box
            width="800px"
            elevation={0}
            sx={{
              border: "1px solid #e0e0e0",
              borderTop: "none", // 여기 핵심
              borderRadius: "0 0 8px 8px",
              // maxHeight: "50vh",
              height: "745px",
              overflowY: "auto",
              overflowX: 'hidden'
            }}
          >
            {/* 상품 테이블 */}
            <CommerceProductTable
              products={paginatedProducts}
              selectedProducts={selectedTrendProduct}
              onToggle={toggleProduct}
              checkoutToggleAll={setSelectedTrendProduct}
              isLoading={isLoading}
              CustomRankChangeCell={CustomRankChangeCell}
            />
          </Box>
          {/* 페이징 처리 */}
          <PaginationWithInfo 
            totalCount={products.length}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            isLoading={isLoading}
          />
        </Box>
        <Box sx={{px: 0, py: 0}}>
          <Box
            sx={{
              width: "750px",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              overflow: "hidden",
              mt: 0
            }}
          >
            {/* 상단 검색창/타이틀 영역 */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={2}
              borderBottom="1px solid #e0e0e0"
              bgcolor="#fff"
            >
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    opacity: (isChartLoading || isLoading) ? 0.4 : 1,
                    transition: "opacity 0.3s ease",
                    pointerEvents: (isChartLoading || isLoading) ? "none" : "auto",
                  }}
                >
                  <CustomDatePicker 
                    selectedDate={selectedChartStartDate}
                    setSelectedDate={setSelectedChartStartDate}
                    inputRef={inputRefTableDate}
                    label="시작일"
                  />
                  <CustomDatePicker 
                    selectedDate={selectedChartEndDate}
                    setSelectedDate={setSelectedChartEndDate}
                    inputRef={inputRefTableDate}
                    label="종료일"
                  />
                </Box>
              </Grid>
            </Box>
            {/* 그래프 영역 */}
            <Box sx={{ p: 2, bgcolor: "#fff" }}>
              <Box
                sx={{
                  opacity: (isChartLoading || isLoading) ? 0.4 : 1,
                  transition: "opacity 0.3s ease",
                  pointerEvents: (isChartLoading || isLoading) ? "none" : "auto",
                }}
              >
                <CommerceProductTrendChart 
                  selectedChartStartDate={selectedChartStartDate}
                  selectedChartEndDate={selectedChartEndDate}
                  selectedTrendProduct={selectedTrendProduct}
                  chartProducts={chartProducts} 
                />
              </Box>
            </Box>
            {/* 그래프 영역 */}
            <Box sx={{ p: 2, bgcolor: "#fff" }}>
              <Box
                sx={{
                  opacity: (isChartLoading || isLoading) ? 0.4 : 1,
                  transition: "opacity 0.3s ease",
                  pointerEvents: (isChartLoading || isLoading) ? "none" : "auto",
                }}
              >
                <CommerceProductPriceTrendChart 
                  selectedChartStartDate={selectedChartStartDate}
                  selectedChartEndDate={selectedChartEndDate}
                  selectedTrendProduct={selectedTrendProduct}
                  chartProducts={chartProducts} 
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
}

export default RankTrendCommerce;
